import { Box, CircularProgress, Stack } from "@mui/material";
import { Button } from "@src/appV2/redesign/components/Button";
import { Text } from "@src/appV2/redesign/components/Text";

import { AccountSwitcherOption } from "../../Shared/AccountSwitcher/AccountSwitcherOption";
import { type AccountSwitcherUser, type UserDetails } from "../../Shared/AccountSwitcher/types";

interface AccountSwitcherOptionGroupMobileProps {
  userDetails: UserDetails;
  onUserClicked: (user: AccountSwitcherUser) => void;
  loadMoreLabel: string;
}

export function AccountSwitcherOptionGroupMobile(props: AccountSwitcherOptionGroupMobileProps) {
  const { userDetails, onUserClicked, loadMoreLabel } = props;
  const listCount = userDetails?.list.length || 0;

  if (!userDetails.loading && !listCount) {
    return (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100%",
          minHeight: "150px",
        }}
      >
        <Text italic variant="body2" color={(theme) => theme.palette.navbar?.itemContent}>
          No records found
        </Text>
      </Box>
    );
  }

  const userList: AccountSwitcherUser[] | undefined = userDetails?.list;

  return (
    <Stack gap={0}>
      {userList.map((user: AccountSwitcherUser) => (
        <AccountSwitcherOption
          key={user.userId}
          title={user.title}
          subtitles={user.subtitles}
          stage={user.stage}
          onClick={() => {
            onUserClicked(user);
          }}
        />
      ))}
      {userDetails.loading ? (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
            minHeight: "150px",
          }}
        >
          <CircularProgress
            size={16}
            sx={(theme) => ({ color: theme.palette.navbar?.itemContent })}
          />
        </Box>
      ) : userDetails.isFetchingNextPage ? (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: 2,
          }}
        >
          <CircularProgress
            size={16}
            sx={(theme) => ({ color: theme.palette.navbar?.itemContent })}
          />
        </Box>
      ) : (
        userDetails.hasNextPage &&
        userDetails.fetchNextPage && (
          <Button
            fullWidth
            variant="linkInverted"
            size="small"
            sx={{ borderRadius: 0 }}
            onClick={async () => await userDetails.fetchNextPage?.()}
          >
            {loadMoreLabel}
          </Button>
        )
      )}
    </Stack>
  );
}
